import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import AbstractViewManage from '@/class/view/AbstractViewManage'
import { Company } from '@/class/model/mdm/Company'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { queryMAWBInfo } from '@/api/partner/mawbInfo'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { isArray } from '@/utils/validate'
import { AirPortRequirement } from '@/class/model/mdm/AirPortRequirement'
import { AirCargoDocUtil } from '@/class/cargo/model/utils/AirCargoDocUtil'
import { cache } from '@/utils/cacheManager'
import $store from '@/store'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { AirImportJob } from '@/class/model/booking/AirImportJob'

export class TabMAWBPM extends AbstractViewManage {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.view = view
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.form = form
  }
  /**
   * 把model属性填充到表单
   */
  async fillView() {
    if (this.job) {
      this.form = new AirCargoDoc().fillDefaultValue().getData()
      if (!this.view.isEdit) {
        const cargoDoc = await new AirImportJob(this.job).getCargoDoc(CargoDocConsts.MAWB, false)
        if (cargoDoc) {
          this.form = cargoDoc
        }
        if (this.form.uuid) {
          await new AirCargoDoc(this.form).getOtherCharge()
        }
      } else {
        this.form = await new AirImportJob(this.job).getCargoDoc(CargoDocConsts.MAWB, true)
        if (this.form.uuid) {
          await new AirCargoDoc(this.form).getOtherCharge()
        } else {
          if (!this.job.airCargoDoc || this.job.airCargoDoc.length === 0) {
            this.job.airCargoDoc = []
          }
          let hasMawb = false
          for (const item of this.job.airCargoDoc) {
            if (item.docType === CargoDocConsts.MAWB) {
              hasMawb = true
              break
            }
          }
          if (!hasMawb) {
            this.job.airCargoDoc.push(this.form)
          }
        }
      }
      this.view.airPortRequirement = new AirPortRequirement().fillDefaultValue().getData()
      this.view.airPortRequirement = await AirCargoDocUtil.getAirportRequirement(this.job, CargoDocConsts.MAWB)
      if (!this.view.airPortRequirement) {
        this.view.airPortRequirement = new AirPortRequirement().fillDefaultValue().getData()
      }
      this.view.airPortRequirementFileList = []
      this.view.airPortRequirementFileList = await AirCargoDocUtil.getAirPortRequirementFileList(this.view.airPortRequirement.uuid)
      if (this.view.airPortRequirementFileList && this.view.airPortRequirementFileList.length > 0) {
        this.view.airPortRequirementText = this.view.$t('AirExport.AttachmentDescription') + this.view.airPortRequirementFileList.length + this.view.$t('CargoMsg.Cargo_Pcs')
      }
    }
  }
  //  reset 收发通地址
  onClear(type) {
    switch (type) {
      case 1:
        this.form.shipperId = null
        this.form.shipperCode = ''
        this.form.shipperLine1 = ''
        this.form.shipperLine2 = ''
        this.form.shipperLine3 = ''
        this.form.shipperLine4 = ''
        this.form.shipperLine5 = ''
        this.form.shipperLine6 = ''
        this.form.shipperLine7 = null
        break
      case 2:
        this.form.consigneeId = null
        this.form.consigneeCode = ''
        this.form.consigneeLine1 = ''
        this.form.consigneeLine2 = ''
        this.form.consigneeLine3 = ''
        this.form.consigneeLine4 = ''
        this.form.consigneeLine5 = ''
        this.form.consigneeLine6 = ''
        this.form.consigneeLine7 = ''
        break
      case 3:
        this.form.notifyId = null
        this.form.notifyCode = ''
        this.form.notifyLine1 = ''
        this.form.notifyLine2 = ''
        this.form.notifyLine3 = ''
        this.form.notifyLine4 = ''
        this.form.notifyLine5 = ''
        this.form.notifyLine6 = ''
        this.form.notifyLine7 = null
        break
      case 4:
        this.form.agentPartyLine1 = ''
        this.form.agentPartyLine2 = ''
        this.form.agentPartyLine3 = ''
        this.form.agentPartyLine4 = ''
        this.form.agentPartyLine5 = ''
        this.form.agentPartyLine6 = ''
        this.form.agentPartyLine7 = ''
        break
      default:
        break
    }
  }
  // 表单验证
  validateForm() {
    return true
  }
  // 把表单值填充到model
  fillModel() {
  }
  // 计费重量
  async chargeWeightChangeHandler() {
    this.view.iataPrice = await JobUtils.queryIataPriceCarrier(this.job, this.view.iataPrice)
    this.applyIATAPrice()
  }
  applyIATAPrice() {
    if (this.view.iataPrice) {
      this.view.$refs.part1.refreshTotal()
      this.view.$refs.part1.refreshPPCC()
    }
  }
  // 单号抄录回调函数
  transcribeEnterHandler(rows) {
    const selectedMBL = isArray(rows) ? rows[0] : rows
    if (selectedMBL && Object.keys(selectedMBL).length > 0) {
      this.form.shipperCode = selectedMBL.shipperCode
      this.form.shipperLine1 = selectedMBL.shipperLine1
      this.form.shipperLine2 = selectedMBL.shipperLine2
      this.form.shipperLine3 = selectedMBL.shipperLine3
      this.form.shipperLine4 = selectedMBL.shipperLine4
      this.form.shipperLine5 = selectedMBL.shipperLine5
      this.form.shipperLine6 = selectedMBL.shipperLine6
      this.form.consigneeCode = selectedMBL.consigneeCode
      this.form.consigneeLine1 = selectedMBL.consigneeLine1
      this.form.consigneeLine2 = selectedMBL.consigneeLine2
      this.form.consigneeLine3 = selectedMBL.consigneeLine3
      this.form.consigneeLine4 = selectedMBL.consigneeLine4
      this.form.consigneeLine5 = selectedMBL.consigneeLine5
      this.form.consigneeLine6 = selectedMBL.consigneeLine6
      this.form.consigneeLine7 = selectedMBL.consigneeLine7
    }
  }
  // 刷新合作伙伴航空公司信息
  async airlineBtnHandler() {
    const job = this.job
    if (job && job.carrierId === 0) {
      this.view.$message.warning(this.view.$t('AirExport.AirlineCannotBeEmpty'))
      return
    }
    const carrier = await Company.getCompanyById(job.carrierId)
    if (!carrier) {
      this.view.$message.warning(this.view.$t('queryJob.AirlineCachePleaseResetAgain'))
      return
    }
    this.$confirm(this.view.$t('queryJob.ResettingTheModifiedContentContinue'), this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      closeOnClickModal: false,
      type: 'warning'
    }).then(async() => {
      await queryMAWBInfo({ airline: carrier.shortName, branchId: this.$store.getters.currentOfficeId }).then(async res => {
        if (res && res.data && res.data.length > 0) {
          if (res.data.length === 1) {
            this.selectCallBackHandler(res.data[0])
          } else {
            this.view.mawbInfoDialog.items = res.data
            this.view.mawbInfoDialog.visible = true
          }
        }
      })
    }).catch(() => {
    })
  }
  selectCallBackHandler(mawbInfo) {
    AirExportUtils.refMawbInfo(this.job, this.form, mawbInfo)
    if (mawbInfo.mawbInfoOtherCharge && mawbInfo.mawbInfoOtherCharge.length > 0) {
      this.view.$refs.part1.refreshOtherCharge()
    }
  }
  executeTask() {
    this.view.addrPM.job = this.job
    this.view.addrPM.shipperCodeField = 'shipperCode'
    this.view.addrPM.shipperField = 'shipperLine'
    this.view.addrPM.consigneeCodeField = 'consigneeCode'
    this.view.addrPM.consigneeField = 'consigneeLine'
    this.view.addrPM.notifyCodeField = 'notifyCode'
    this.view.addrPM.notifyField = 'notifyLine'
    if (parseInt(cache.config.get('syncMailingAddress')) === 1) {
      this.view.addrPM.aeSaveCheck()
    }
  }
}
